import { createContext, useContext, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { apiSae } from "../services/api";
import { HomeContext } from "./ContextHome";
import { Zoom, toast } from "react-toastify";

export const AdminContext = createContext({});

export const AdminProvider = () => {
  const { infoUser, headerApi } = useContext(HomeContext);

  const [modalCreateUser, setModalCreateUser] = useState(false);
  const [modalUpdateUser, setModalUpdateUser] = useState(false);
  const [modalDesableUser, setDesableUser] = useState(false);

  const [createEstacao, setCreateEstacao] = useState([]);
  const [updateEstacao, setUpdateEstacao] = useState([]);
  const [modalsDesableEstacao, setDesableEstacao] = useState(false);

  const [modalCreateEstacao, setModalCreateEstacao] = useState(false);
  const [modalCreatePoco, setModalCreatePoco] = useState(false);
  const [modalCreateBomba, setModalCreateBomba] = useState(false);
  const [modalCreateBombaPoco2, setModalCreateBombaPoco2] = useState(false);

  const [modalUpdateEstacao, setModalUpdateEstacao] = useState(false);

  const [modalResetGtwOn, setModalResetGtwOn] = useState(false);
  const [componenteCriaNovoPoco, setComponenteCriaNovoPoco] = useState(false);
  const [componenteCriaNovaBomba, setComponenteCriaNovaBomba] = useState(false);
  const [novoPocoCadastro, setNovoPocoCadastro] = useState(null);

  const [listarGeral, setListarGeral] = useState({});

  const [users, setUsers] = useState([]);
  const [estacoes, setEstacoes] = useState([]);
  const [pocos, setPocos] = useState([]);
  const [bombas, setBombas] = useState([]);

  const [idBombas, setIdBombas] = useState();

  const [selecionaUsuario, setSelecionaUsuario] = useState([]);
  const [selecionaEstacoes, setSelecionaEstacoes] = useState([]);
  const [selecionaPocos, setSelecionaPocos] = useState([]);
  const [selecionaBombas, setSelecionaBombas] = useState(0);

  const [componenteEstacao, setComponenteEstacao] = useState("Estacao");
  const [salvandoEstacao, setSalvandoEstacao] = useState(false);

  const exibirErro = (mensagem) => {
    toast.error(mensagem, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Zoom,
      className: "custom-toast",
      bodyClassName: "custom-toast",
      progressClassName: "custom-toast .Toastify__progress-bar",
      icon: "custom-toast-icon",
    });
  };

  const aoCriarUsuario = async (dados) => {
    const tratativa = {
      usuario: dados.usuario,
      nome: dados.nome,
      email: dados.email,
      role: dados.role,
      password: dados.password,
      matricula: dados.matricula,
    };

    try {
      await apiSae.post("users", tratativa, headerApi);
      const atualiza = await apiSae.get("users/LeituraTodos", headerApi);
      setUsers(atualiza.data);
      setModalCreateUser(false);

      toast.success("Cadastro Realizado com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error(error.response?.data?.status || "Operação não autorizada", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Zoom,
          className: "custom-toast", // Classe personalizada para o toast
          bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
          progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
          icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
        });
      } else {
        toast.error("Algo deu errado!", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Zoom,
          className: "custom-toast", // Classe personalizada para o toast
          bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
          progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
          icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
        });
      }
    } finally {
    }
  };

  const aoEditarUsuario = async (dados) => {
    const tratativa = {
      usuario: dados.usuario,
      nome: dados.nome,
      email: dados.email,
      role: dados.role,
      matricula: dados.matricula,
    };

    if (dados.password) {
      tratativa.password = dados.password;
    }

    try {
      await apiSae.patch(`users/${selecionaUsuario[0]}/`, tratativa, headerApi);

      const atualiza = await apiSae.get("users/LeituraTodos", headerApi);
      setUsers(atualiza.data);
      setModalUpdateUser(false);

      toast.success("Cadastro Editado com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const mensagemErro =
          error.response.data?.message === "Email already exists"
            ? "Este e-mail já está cadastrado."
            : error.response.data?.message || "Erro de conflito.";

        exibirErro(mensagemErro);
      } else {
        exibirErro("Algo deu errado ao editar o usuário!");
      }
    } finally {
    }
  };

  const aoDesabilitaUsuario = async () => {
    const alteraAtivo = {
      is_active: !selecionaUsuario[1],
    };
    try {
      await apiSae.patch(
        `users/${selecionaUsuario[0]}/`,
        alteraAtivo,
        headerApi
      );
      const atualiza = await apiSae.get("users/LeituraTodos", headerApi);
      setUsers(atualiza.data);
      toast.success(
        `Cadastro ${
          selecionaUsuario[1] === true ? "Desativado" : "Ativado"
        } com sucesso!`,
        {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Zoom,
          className: "custom-toast", // Classe personalizada para o toast
          bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
          progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
          icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
        }
      );
    } catch (error) {
      console.log(error);
      toast.error("⚠️ Algo deu errado!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } finally {
      setDesableUser(false);
    }
  };

  const aoSalvarDados = async (dadosCadastro = createEstacao) => {
    const createEstacao = dadosCadastro;
    setSalvandoEstacao(true);
    try {
      const tratativaEstacao = {
        cidade: createEstacao[0].cidade,
        nome_estacao: createEstacao[0].nome_estacao,
        tipo: createEstacao[0].tipo,
        codigo: createEstacao[0].codigo,
        possui_gerador: createEstacao[0].possui_gerador,
        ativo: createEstacao[0].ativo,
      };

      const criarEstacao = await apiSae.post(
        "estacao",
        tratativaEstacao,
        headerApi
      );

      if (createEstacao[0].possui_gerador === true) {
        await apiSae.post(
          "gerador",
          {
            estacao: criarEstacao.data.id,
          },
          headerApi
        );
      }

      if (createEstacao[0].quantidadePocos === 1) {
        const tratativaPoco1 = {
          estacao: criarEstacao.data.id,
          altura_poco: createEstacao[1].altura_poco,
          altura_util_poco: createEstacao[1].altura_util_poco,
          nivel_atual: 0,
          nivel_minimo: createEstacao[1].nivel_minimo,
          nivel_maximo: createEstacao[1].nivel_maximo,
          cesta: createEstacao[1].cesta,
          quantidade_bombas: createEstacao[1].quantidade_bombas,
        };

        const criarPoco1 = await apiSae.post("poco", tratativaPoco1, headerApi);

        if (createEstacao[1].cesta === true) {
          const tratativaCesta = {
            poco: criarPoco1.data.id,
          };
          await apiSae.post("cesta", tratativaCesta, headerApi);
        }

        const tratativaBomba = {
          poco: criarPoco1.data.id,
          nivel: 0,
          rpm: 0,
          tensao: 0,
          corrente: 0,
          frequencia: 0,
          horimetro: 0,
          status: 0,
          imagem: "",
          tipo_bomba: createEstacao[2].tipo_bomba,
          nivel_acionamento: createEstacao[2].nivel_acionamento,
          nivel_desligamento: createEstacao[2].nivel_desligamento,
        };

        const bomba = await apiSae.post("bomba", tratativaBomba, headerApi);
        await apiSae.post(
          "bomba/controle",
          { bomba: bomba.data.id },
          headerApi
        );

        if (createEstacao[1].quantidade_bombas >= 2) {
          const tratativaBomba2 = {
            poco: criarPoco1.data.id,
            nivel: 0,
            rpm: 0,
            tensao: 0,
            corrente: 0,
            frequencia: 0,
            horimetro: 0,
            status: 0,
            imagem: "",
            tipo_bomba: createEstacao[2].tipo_bomba2,
            nivel_acionamento: createEstacao[2].nivel_acionamento2,
            nivel_desligamento: createEstacao[2].nivel_desligamento2,
            numero_bomba: 2,
          };

          const bomba2 = await apiSae.post("bomba", tratativaBomba2, headerApi);

          await apiSae.post(
            "bomba/controle",
            { bomba: bomba2.data.id },
            headerApi
          );
        }

        if (createEstacao[1].quantidade_bombas === 3) {
          const tratativaBomba3 = {
            poco: criarPoco1.data.id,
            nivel: 0,
            rpm: 0,
            tensao: 0,
            corrente: 0,
            frequencia: 0,
            horimetro: 0,
            status: 0,
            imagem: "",
            tipo_bomba: createEstacao[2].tipo_bomba3,
            nivel_acionamento: createEstacao[2].nivel_acionamento3,
            nivel_desligamento: createEstacao[2].nivel_desligamento3,
            numero_bomba: 3,
          };

          const bomba3 = await apiSae.post("bomba", tratativaBomba3, headerApi);

          await apiSae.post(
            "bomba/controle",
            { bomba: bomba3.data.id },
            headerApi
          );
        }
      }

      if (createEstacao[0].quantidadePocos === 2) {
        const tratativaPoco1 = {
          estacao: criarEstacao.data.id,
          altura_poco: createEstacao[1].altura_poco,
          altura_util_poco: createEstacao[1].altura_util_poco,
          nivel_atual: 0,
          nivel_minimo: createEstacao[1].nivel_minimo,
          nivel_maximo: createEstacao[1].nivel_maximo,
          cesta: createEstacao[1].cesta,
          quantidade_bombas: createEstacao[1].quantidade_bombas,
        };

        const criarPoco1 = await apiSae.post("poco", tratativaPoco1, headerApi);

        if (createEstacao[1].cesta === true) {
          const tratativaCesta = {
            poco: criarPoco1.data.id,
          };
          await apiSae.post("cesta", tratativaCesta, headerApi);
        }

        const tratativaBombaPoco1 = {
          poco: criarPoco1.data.id,
          nivel: 0,
          rpm: 0,
          tensao: 0,
          corrente: 0,
          frequencia: 0,
          horimetro: 0,
          status: 0,
          imagem: "",
          tipo_bomba: createEstacao[2].tipo_bomba,
          nivel_acionamento: createEstacao[2].nivel_acionamento,
          nivel_desligamento: createEstacao[2].nivel_desligamento,
        };

        const bomba = await apiSae.post(
          "bomba",
          tratativaBombaPoco1,
          headerApi
        );

        await apiSae.post(
          "bomba/controle",
          { bomba: bomba.data.id },
          headerApi
        );

        if (createEstacao[1].quantidade_bombas >= 2) {
          const tratativaBomba2 = {
            poco: criarPoco1.data.id,
            nivel: 0,
            rpm: 0,
            tensao: 0,
            corrente: 0,
            frequencia: 0,
            horimetro: 0,
            status: 0,
            imagem: "",
            tipo_bomba: createEstacao[2].tipo_bomba2,
            nivel_acionamento: createEstacao[2].nivel_acionamento2,
            nivel_desligamento: createEstacao[2].nivel_desligamento2,
            numero_bomba: 2,
          };

          const bomba2 = await apiSae.post("bomba", tratativaBomba2, headerApi);

          await apiSae.post(
            "bomba/controle",
            { bomba: bomba2.data.id },
            headerApi
          );
        }

        if (createEstacao[1].quantidade_bombas === 3) {
          const tratativaBomba3 = {
            poco: criarPoco1.data.id,
            nivel: 0,
            rpm: 0,
            tensao: 0,
            corrente: 0,
            frequencia: 0,
            horimetro: 0,
            status: 0,
            imagem: "",
            tipo_bomba: createEstacao[2].tipo_bomba3,
            nivel_acionamento: createEstacao[2].nivel_acionamento3,
            nivel_desligamento: createEstacao[2].nivel_desligamento3,
            numero_bomba: 3,
          };

          const bomba3 = await apiSae.post("bomba", tratativaBomba3, headerApi);

          await apiSae.post(
            "bomba/controle",
            { bomba: bomba3.data.id },
            headerApi
          );
        }

        // Criação do Posso 2
        const tratativaPoco2 = {
          estacao: criarEstacao.data.id,
          altura_poco: createEstacao[1].altura_poco2,
          altura_util_poco: createEstacao[1].altura_util_poco2,
          nivel_atual: 0,
          nivel_minimo: createEstacao[1].nivel_minimo2,
          nivel_maximo: createEstacao[1].nivel_maximo2,
          cesta: createEstacao[1].cesta2,
          numero_poco: 2,
          quantidade_bombas: createEstacao[1].quantidade_bombas2,
        };

        const criarPoco2 = await apiSae.post("poco", tratativaPoco2, headerApi);

        if (createEstacao[1].cesta2 === true) {
          await apiSae.post(
            "cesta",
            { poco: criarPoco2.data.id },
            headerApi
          );
        }

        const tratativaBombaPoco2 = {
          poco: criarPoco2.data.id,
          nivel: 0,
          rpm: 0,
          tensao: 0,
          corrente: 0,
          frequencia: 0,
          horimetro: 0,
          status: 0,
          imagem: "",
          tipo_bomba: createEstacao[3].tipo_bomba,
          nivel_acionamento: createEstacao[3].nivel_acionamento,
          nivel_desligamento: createEstacao[3].nivel_desligamento,
          numero_bomba: 1,
        };

        const bombaPoco1 = await apiSae.post(
          "bomba",
          tratativaBombaPoco2,
          headerApi
        );

        await apiSae.post(
          "bomba/controle",
          { bomba: bombaPoco1.data.id },
          headerApi
        );

        if (createEstacao[1].quantidade_bombas2 >= 2) {
          const tratativaBomba2 = {
            poco: criarPoco2.data.id,
            nivel: 0,
            rpm: 0,
            tensao: 0,
            corrente: 0,
            frequencia: 0,
            horimetro: 0,
            status: 0,
            imagem: "",
            tipo_bomba: createEstacao[3].tipo_bomba2,
            nivel_acionamento: createEstacao[3].nivel_acionamento2,
            nivel_desligamento: createEstacao[3].nivel_desligamento2,
            numero_bomba: 2,
          };

          const bomba2Poco = await apiSae.post(
            "bomba",
            tratativaBomba2,
            headerApi
          );

          await apiSae.post(
            "bomba/controle",
            { bomba: bomba2Poco.data.id },
            headerApi
          );
        }

        if (createEstacao[1].quantidade_bombas2 === 3) {
          const tratativaBomba3 = {
            poco: criarPoco2.data.id,
            nivel: 0,
            rpm: 0,
            tensao: 0,
            corrente: 0,
            frequencia: 0,
            horimetro: 0,
            status: 0,
            imagem: "",
            tipo_bomba: createEstacao[3].tipo_bomba3,
            nivel_acionamento: createEstacao[3].nivel_acionamento3,
            nivel_desligamento: createEstacao[3].nivel_desligamento3,
            numero_bomba: 3,
          };

          const bomba3Poco = await apiSae.post(
            "bomba",
            tratativaBomba3,
            headerApi
          );

          await apiSae.post(
            "bomba/controle",
            { bomba: bomba3Poco.data.id },
            headerApi
          );
        }
      }

      const atualizaEstacoes = await apiSae.get(
        "estacao/leituratodos",
        headerApi
      );
      setEstacoes(atualizaEstacoes.data);
      setCreateEstacao([]);
      toast.success("Estação criada com sucesso!", {
        position: "top-right",
        autoClose: 1500,
        theme: "light",
        transition: Zoom,
      });
      return true;
    } catch (error) {
      console.error("Erro ao criar estação:", error);
      exibirErro(
        error.response?.data?.status ||
          error.response?.data?.message ||
          "Não foi possível concluir o cadastro da estação."
      );
      return false;
    } finally {
      setSalvandoEstacao(false);
    }
  };

  const aoCriarNovoPoco = async (dados) => {
    try {
      const tratativaNovoPoco = {
        estacao: listarGeral.id,
        altura_poco: dados.altura_poco,
        altura_util_poco: dados.altura_util_poco,
        nivel_atual: 0,
        nivel_minimo: dados.nivel_minimo,
        nivel_maximo: dados.nivel_maximo,
        cesta: dados.cesta,
        quantidade_bombas: dados.quantidade_bombas,
      };

      const criarNovoPoco = await apiSae.post(
        "poco",
        tratativaNovoPoco,
        headerApi
      );

      const atualizaQtdPoco = await apiSae.get("poco/leituratodos", headerApi);
      setPocos(atualizaQtdPoco.data);

      if (dados.cesta === true) {
        const tratativaCesta = {
          poco: criarNovoPoco.data.id,
        };
        await apiSae.post("cesta", tratativaCesta, headerApi);
      }

      const estacaoAtualizada = await apiSae.get(
        `estacao/leitura/${listarGeral.id}`,
        headerApi
      );
      setListarGeral(estacaoAtualizada.data);
      setNovoPocoCadastro({
        id: criarNovoPoco.data.id,
        quantidade_bombas: Number(dados.quantidade_bombas),
      });
      setComponenteCriaNovoPoco(false);
      setComponenteCriaNovaBomba(true);

      toast.success("Novo Poço Criado com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      console.log(error);
      exibirErro("Algo deu errado!");
    }
  };

  const aoCriarNovaBomba = async (dados) => {
    if (!novoPocoCadastro?.id || !Array.isArray(dados.bombas)) {
      exibirErro("Dados do novo poço ou das bombas estão incompletos.");
      return false;
    }

    try {
      for (const [index, dadosBomba] of dados.bombas.entries()) {
        const tratativaBomba = {
          poco: novoPocoCadastro.id,
          nivel: 0,
          rpm: 0,
          tensao: 0,
          corrente: 0,
          frequencia: 0,
          horimetro: 0,
          status: 0,
          imagem: "",
          tipo_bomba: dadosBomba.tipo_bomba,
          nivel_acionamento: dadosBomba.nivel_acionamento,
          nivel_desligamento: dadosBomba.nivel_desligamento,
          numero_bomba: index + 1,
        };

        const bomba = await apiSae.post("bomba", tratativaBomba, headerApi);
        await apiSae.post(
          "bomba/controle",
          { bomba: bomba.data.id },
          headerApi
        );
      }

      const estacaoAtualizada = await apiSae.get(
        `estacao/leitura/${listarGeral.id}`,
        headerApi
      );
      setListarGeral(estacaoAtualizada.data);
      setNovoPocoCadastro(null);
      setComponenteCriaNovaBomba(false);

      toast.success("Nova Bomba Criado com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
      return true;
    } catch (error) {
      console.log(error);
      exibirErro("Algo deu errado!");
      return false;
    }
  };

  const aoEditarDadosEstacao = async (dados) => {
    try {
      await apiSae.patch(`estacao/${selecionaEstacoes[0]}`, dados, headerApi);

      const atualizaEstacoes = await apiSae.get(
        "estacao/leituratodos",
        headerApi
      );

      setEstacoes(atualizaEstacoes.data);

      const estacaoAtualizada = atualizaEstacoes.data.find(
        (estacao) => estacao.id === selecionaEstacoes[0]
      );

      setListarGeral(estacaoAtualizada); // Atualiza o estado da estação exibida

      toast.success("Estação Editada com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      console.log(error);
      if (error.response?.status === 409) {
        exibirErro(error.response?.data?.status || "Dados já cadastrados");
      } else {
        exibirErro("Algo deu errado!");
      }
    } finally {
    }
  };

  const aoEditarDadosPoco1 = async (dados) => {
    try {
      await apiSae.patch(`poco/${listarGeral.pocos[0].id}`, dados, headerApi);

      const atualizaPocos = await apiSae.get("poco/leituratodos", headerApi);

      setPocos(atualizaPocos.data);

      const pocoAtualizado = atualizaPocos.data.find(
        (poco) => poco.id === listarGeral.pocos[0].id
      );

      if (pocoAtualizado) {
        setListarGeral((prev) => ({
          ...prev,
          pocos: (prev.pocos || []).map((poco) =>
            poco.id === pocoAtualizado.id
              ? {
                  ...poco,
                  ...pocoAtualizado,
                  bombas: pocoAtualizado.bombas ?? poco.bombas,
                }
              : poco
          ),
        }));
      }

      toast.success("Poço Editado com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      console.log(error);
      if (error.response?.status === 409) {
        exibirErro(error.response?.data?.status || "Dados já cadastrados");
      } else {
        exibirErro("Algo deu errado!");
      }
    } finally {
    }
  };

  const aoEditarDadosPoco2 = async (dados) => {
    try {
      await apiSae.patch(`poco/${listarGeral.pocos[1].id}`, dados, headerApi);

      const atualizaPocos = await apiSae.get("poco/leituratodos", headerApi);

      setPocos(atualizaPocos.data);

      const pocoAtualizado = atualizaPocos.data.find(
        (poco) => poco.id === listarGeral.pocos[1].id
      );

      if (pocoAtualizado) {
        setListarGeral((prev) => ({
          ...prev,
          pocos: (prev.pocos || []).map((poco) =>
            poco.id === pocoAtualizado.id
              ? {
                  ...poco,
                  ...pocoAtualizado,
                  bombas: pocoAtualizado.bombas ?? poco.bombas,
                }
              : poco
          ),
        }));
      }
      // setListarGeral(pocoAtualizado); // Atualiza o estado da estação exibida

      toast.success("Poço Editado com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      console.log(error);
      if (error.response?.status === 409) {
        exibirErro(error.response?.data?.status || "Dados já cadastrados");
      } else {
        exibirErro("Algo deu errado!");
      }
    } finally {
    }
  };

  const aoEditarDadosBombas = async (dados) => {
    try {
      const bombasForm = dados.bombas;
      const indicePoco = idBombas === "Poco2" ? 1 : 0;
      const pocoSelecionado = listarGeral.pocos?.[indicePoco];
      const bombasPoco = pocoSelecionado?.bombas || [];

      if (!pocoSelecionado || bombasPoco.length === 0) {
        exibirErro("Nenhuma bomba encontrada para o poço selecionado.");
        return;
      }

      const requisicoes = bombasForm
        .map((bomba, index) => {
          const id = bombasPoco[index]?.id;
          if (!id) return null; // segurança: evita erro se faltar id
          return apiSae.patch(`bomba/${id}`, bomba, headerApi);
        })
        .filter(Boolean); // remove os 'null' caso existam

      await Promise.all(requisicoes); // aguarda todas as requisições

      // Atualiza o estado após salvar
      const atualizaBomba = await apiSae.get("bomba/LeituraTodos", headerApi);
      setBombas(atualizaBomba.data);

      // Filtra as bombas atualizadas que pertencem ao poço 1
      const bombasPorId = new Map(
        atualizaBomba.data.map((bomba) => [bomba.id, bomba])
      );
      const bombasAtualizadas = bombasPoco.map(
        (bomba) => bombasPorId.get(bomba.id) || bomba
      );

      setListarGeral((prev) => ({
        ...prev,
        pocos: (prev.pocos || []).map((poco, index) =>
          index === indicePoco ? { ...poco, bombas: bombasAtualizadas } : poco
        ),
      }));

      toast.success(`Bombas do Poço ${indicePoco + 1} editadas com sucesso!`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } catch (error) {
      console.log(error);
      exibirErro(error.response?.data?.status || "Não foi possível editar as bombas");
    }
  };

  const aoDesabilitarEstacao = async () => {
    const alteraAtivo = {
      ativo: !selecionaEstacoes[1],
    };

    try {
      await apiSae.patch(
        `estacao/${selecionaEstacoes[0]}`,
        alteraAtivo,
        headerApi
      );

      const atualiza = await apiSae.get("estacao/leituratodos", headerApi);
      setEstacoes(atualiza.data);

      toast.success(
        `Estação ${
          selecionaEstacoes[1] === true ? "Desativado" : "Ativado"
        } com sucesso!`,
        {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Zoom,
          className: "custom-toast", // Classe personalizada para o toast
          bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
          progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
          icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
        }
      );
    } catch (error) {
      console.log(error);
      toast.error("⚠️ Algo deu errado!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
        className: "custom-toast", // Classe personalizada para o toast
        bodyClassName: "custom-toast", // Classe personalizada para o corpo do toast
        progressClassName: "custom-toast .Toastify__progress-bar", // Classe personalizada para a barra de progresso
        icon: "custom-toast-icon", // Classe personalizada para o ícone do toast
      });
    } finally {
      setDesableEstacao(false);
    }
  };

  const aoListarGeral = async () => {
    try {
      const listarGeralget = await apiSae.get(
        `estacao/leitura/${selecionaEstacoes[0]}`,
        headerApi
      );

      setListarGeral(listarGeralget.data);

      setModalUpdateEstacao(true);
    } catch (error) {}
  };

  const perfilCarregado = Boolean(infoUser.role);
  const perfilAdministrador = infoUser.role === "3" || infoUser.role === "4";

  if (!perfilCarregado) {
    return <div role="status" aria-live="polite" aria-busy="true" />;
  }

  if (!perfilAdministrador) {
    return <Navigate to="/" replace />;
  }

  return (
    <AdminContext.Provider
      value={{
        users,
        setUsers,
        modalCreateUser,
        setModalCreateUser,
        modalUpdateUser,
        setModalUpdateUser,
        modalDesableUser,
        setDesableUser,
        aoCriarUsuario,
        aoEditarUsuario,
        aoDesabilitaUsuario,
        createEstacao,
        setCreateEstacao,
        updateEstacao,
        aoEditarDadosEstacao,
        aoEditarDadosPoco1,
        aoEditarDadosPoco2,
        aoEditarDadosBombas,
        setUpdateEstacao,
        modalCreateEstacao,
        setModalCreateEstacao,
        modalUpdateEstacao,
        setModalUpdateEstacao,
        modalCreatePoco,
        setModalCreatePoco,
        modalCreateBomba,
        setModalCreateBomba,
        modalCreateBombaPoco2,
        setModalCreateBombaPoco2,
        aoSalvarDados,
        // aoEditarDados,
        exibirErro,
        listarGeral,
        setListarGeral,
        estacoes,
        setEstacoes,
        headerApi,
        selecionaUsuario,
        setSelecionaUsuario,
        selecionaEstacoes,
        setSelecionaEstacoes,
        pocos,
        setPocos,
        selecionaPocos,
        setSelecionaPocos,
        bombas,
        setBombas,
        idBombas,
        setIdBombas,
        selecionaBombas,
        setSelecionaBombas,
        aoListarGeral,
        modalResetGtwOn,
        setModalResetGtwOn,
        componenteEstacao,
        setComponenteEstacao,
        salvandoEstacao,
        componenteCriaNovoPoco,
        setComponenteCriaNovoPoco,
        aoCriarNovoPoco,
        aoCriarNovaBomba,
        componenteCriaNovaBomba,
        setComponenteCriaNovaBomba,
        novoPocoCadastro,
        aoDesabilitarEstacao,
        modalsDesableEstacao,
        setDesableEstacao,
      }}
    >
      <Outlet />
    </AdminContext.Provider>
  );
};
